import {
  ExtendedViewService,
  ExtendedServicePayload,
  ExtendedServiceResponse,
} from "@/types/extendedViewService";
import { RequestOptions } from "@/types/api";
import { createApiClient } from "./client";

export const fetchExtendedViewServices = async (
  userId: string,
  receiptId: string,
  options?: RequestOptions,
  clientServiceScope?: string
): Promise<ExtendedViewService[]> => {
  const client = createApiClient(options);

  const searchParams = clientServiceScope
    ? { client_service_scope: clientServiceScope }
    : undefined;

  return await client
    .get(`view/users/${userId}/receipts/${receiptId}/services/extended`, {
      searchParams,
    })
    .json<ExtendedViewService[]>();
};

export const sendReceiptPdfEmail = async (
  userId: string,
  receiptId: string,
  payload: { email: string; lang: string; storeName?: string | null }
): Promise<void> => {
  const client = createApiClient();

  const body: { email: string; store_name?: string } = { email: payload.email };
  if (payload.storeName) body.store_name = payload.storeName;

  await client.post(
    `view/users/${userId}/receipts/${receiptId}/services/extended/email/pdf`,
    {
      searchParams: { lang: payload.lang },
      json: body,
    }
  );
};

export const callExtendedService = async (
  userId: string,
  receiptId: string,
  payload: ExtendedServicePayload
): Promise<ExtendedServiceResponse> => {
  const client = createApiClient();

  return await client
    .post(`view/users/${userId}/receipts/${receiptId}/services/extended`, {
      json: payload,
    })
    .json<ExtendedServiceResponse>();
};
